import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  card: {
    backgroundColor: "x80m72e",
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    marginBottom: "xyi6m4r",
    $$css: true
  },
  row: {
    display: "x78zum5",
    alignItems: "x1cy8zhl",
    gap: "x1fsutb",
    rowGap: null,
    columnGap: null,
    paddingInline: "xnxx81d",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    color: "x1heor9g",
    $$css: true
  },
  whereLink: {
    cursor: "x1ypdohk",
    $$css: true
  },
  iconWhen: {
    color: "x1n9cmz0",
    flexShrink: "x2lah0s",
    marginTop: "x72edsj",
    $$css: true
  },
  iconWhere: {
    color: "xm6zed8",
    flexShrink: "x2lah0s",
    marginTop: "x72edsj",
    $$css: true
  },
  col: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    minWidth: "xeuugli",
    flex: "x98rzlu",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    $$css: true
  },
  label: {
    fontSize: "xboafo0",
    fontWeight: "x1sl8krj",
    letterSpacing: "x2ujxvm",
    textTransform: "xtvhhri",
    color: "xarw3lm",
    $$css: true
  },
  value: {
    fontSize: "x1jchvi3",
    fontWeight: "xlr2uoh",
    color: "xtt1gjl",
    marginTop: "x72edsj",
    $$css: true
  },
  subtitle: {
    fontSize: "x1dcheo9",
    color: "xarw3lm",
    marginTop: "x72edsj",
    $$css: true
  },
  divider: {
    height: "xjm9jq1",
    backgroundColor: "x1h40hdj",
    marginInline: "x1nqqfzk",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  openIcon: {
    color: "x1gonuu0",
    flexShrink: "x2lah0s",
    alignSelf: "xamitd3",
    $$css: true
  }
};